export var size = 1
export var noise = 2
export var price = 3



// WEBPACK FOOTER //
// ./src/data/consts.js